import { render } from "./CuotasCreditoList.vue?vue&type=template&id=3ffe0cd8&scoped=true"
import script from "./CuotasCreditoList.vue?vue&type=script&lang=js"
export * from "./CuotasCreditoList.vue?vue&type=script&lang=js"

import "./CuotasCreditoList.vue?vue&type=style&index=0&id=3ffe0cd8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffe0cd8"]])

export default __exports__